import { render, staticRenderFns } from "./Riesgos.vue?vue&type=template&id=7e7a9756&"
import script from "./Riesgos.vue?vue&type=script&lang=js&"
export * from "./Riesgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports